import httpUtils from '../utils/http-utils';

// Previews are stored by the public site (nmu-web), which is also what renders
// them — REACT_APP_PREVIEW_ENDPOINT is that origin. This used to POST to
// nmu-display-service's /public/savePreview, which no longer exists.
const SERVICE_NAME = process.env.REACT_APP_PREVIEW_ENDPOINT;

const savePreview = (payload) => {
    return httpUtils.post(SERVICE_NAME+"/api/preview", payload);
}

const previewApi = {
    savePreview
}

export default previewApi;